import { styled } from '@mui/material';

import { Grid } from '../Grid';
import { PopoverArrow } from '../PopoverArrow';
import { PopoverContentBody } from '../PopoverContentBody';
import { PopoverContentFooter } from '../PopoverContentFooter';
import { PopoverContentHeader } from '../PopoverContentHeader';
import { popoverContentClasses } from './theme';

import type { PopoverContentProps } from './types';

const PopoverContent = (props: PopoverContentProps) => {
  const { arrow, placement = 'top', children, direction = 'column', contents, ...others } = props;

  return (
    <StyledPopoverContent {...others}>
      <Grid container flexDirection={direction}>
        {contents && (
          <Grid container flexDirection={'column'}>
            <PopoverContentHeader {...contents.header} />
            <PopoverContentBody {...contents.body} />
            <PopoverContentFooter {...contents.footer} />
          </Grid>
        )}
        {children}
      </Grid>
      <PopoverArrow arrow={arrow} placement={placement} />
    </StyledPopoverContent>
  );
};

const StyledPopoverContent = styled('div', {
  target: popoverContentClasses.root,
})`
  border-radius: 2px;
  font-size: 12px;
  line-height: 18px;
  color: #131619;
  padding: 8px;
  background-color: white;
  box-shadow:
    0px 0px 1px 0px #13161926,
    0px 3px 6px 0px #13161926;
  max-width: 416px;
`;

export default PopoverContent;
